import { Skeleton as MuiSkeleton, Box } from '@mui/material'
import type { SkeletonProps } from '@mui/material'

export type { SkeletonProps }

/**
 * Thin wrapper around MUI Skeleton with sensible defaults.
 *
 * @example
 * // Single line
 * <Skeleton width={200} />
 *
 * // Block placeholder
 * <Skeleton variant="rectangular" height={120} />
 *
 * // Pre-built card placeholder
 * <Skeleton.Card />
 */
const Skeleton = (props: SkeletonProps) => (
    <MuiSkeleton animation="wave" {...props} />
)

/** A ready-made skeleton for a typical data card (title + 3 rows). */
const CardSkeleton = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <MuiSkeleton animation="wave" width="40%" height={24} />
        <MuiSkeleton animation="wave" width="80%" />
        <MuiSkeleton animation="wave" width="70%" />
        <MuiSkeleton animation="wave" width="60%" />
    </Box>
)

Skeleton.Card = CardSkeleton

export default Skeleton
